import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';
import { handleRequestHelper } from '../../../utils/helpers';
import api from '../../../api/api';
import { useNotifications } from '../../../Providers/NotificationsProvider/NotificationsProvider';

export const useEventPaymentMethodsPage = () => {
  const { eventId } = useParams();
  const { showNotification } = useNotifications();
  const [isLoading, setIsLoading] = useState(true);
  const [mercadopago, setMercadopago] = useState(null);
  const [line, setLine] = useState(null);
  const [dlocal, setDlocal] = useState(null);
  const [modoLine, setModoLine] = useState(null);
  const eventName = useRef('');

  const getEventPaymentMethods = async () => {
    await handleRequestHelper({
      endpoint: () => api.getEventPaymentMethodsAdmin(eventId),
      onSuccess: ({ mercadopago, line, dlocal, modoLine }) => {
        setMercadopago(mercadopago);
        setLine(line);
        setDlocal(dlocal);
        setModoLine(modoLine);
      },
      showNotification,
    });
  };

  const getEventName = async () => {
    await handleRequestHelper({
      endpoint: () => api.getEventName(eventId),
      onSuccess: ({ name }) => {
        eventName.current = name;
      },
    });
  };

  const getInitialData = async () => {
    setIsLoading(true);
    await Promise.all([getEventName(), getEventPaymentMethods()]);
    setIsLoading(false);
  };

  useEffect(() => {
    getInitialData();
  }, []);

  return {
    isLoading,
    mercadopago,
    line,
    dlocal,
    modoLine,
    eventName: eventName.current,
  };
};
